import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { IPaymentSettingsItem } from "web/types/Payment";

import { ProductToSeparateWithPaymentSettings } from "../types";

const sortRulePaymentSuggestion = (
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem,
  context: { product: ProductToSeparateWithPaymentSettings }
) => {
  const { product } = context;

  const suggestion =
    typeof product?.payment_suggestion === "string"
      ? jsonParse(product.payment_suggestion)
      : product.payment_suggestion;

  if (!isArrayHasItems(suggestion)) {
    return 0;
  }

  const firstIndex = suggestion.indexOf(firstPayment.code);
  const secondIndex = suggestion.indexOf(secondPayment.code);

  const firstInSuggestion = firstIndex !== -1;
  const secondInSuggestion = secondIndex !== -1;

  if (firstInSuggestion && !secondInSuggestion) {
    return -1;
  }

  if (!firstInSuggestion && secondInSuggestion) {
    return 1;
  }

  if (firstInSuggestion && secondInSuggestion) {
    if (firstIndex < secondIndex) return -1;
    if (firstIndex > secondIndex) return 1;
  }

  return 0;
};

export default sortRulePaymentSuggestion;
